import { Calendar, Users, CheckCircle, Bell } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, color, darkColor }) => (
  <div className="bg-white dark:bg-slate-800 rounded-lg shadow p-6 border border-transparent dark:border-gray-700 transition-colors">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm text-gray-500 dark:text-gray-400">{title}</p>
        <p className="mt-1 text-2xl font-bold text-gray-900 dark:text-white">{value}</p>
      </div>
      <div className={`h-12 w-12 rounded-full flex items-center justify-center ${color} ${darkColor}`}>
        <Icon className="h-6 w-6" />
      </div>
    </div>
  </div>
);

export const DashboardStats = ({ stats }) => {
  const statCards = [
    {
      title: "Today's Appointments",
      value: stats.todayAppointments,
      icon: Calendar,
      color: 'bg-blue-100 text-blue-600',
      darkColor: 'dark:bg-blue-900/30 dark:text-blue-400'
    },
    {
      title: 'Waitlist',
      value: stats.waitlistCount,
      icon: Users,
      color: 'bg-yellow-100 text-yellow-600',
      darkColor: 'dark:bg-yellow-900/30 dark:text-yellow-400'
    },
    {
      title: 'Check-ins Today',
      value: stats.checkInsToday,
      icon: CheckCircle,
      color: 'bg-green-100 text-green-600',
      darkColor: 'dark:bg-green-900/30 dark:text-green-400'
    },
    {
      title: 'Pending Reminders',
      value: stats.pendingReminders,
      icon: Bell,
      color: 'bg-red-100 text-red-600',
      darkColor: 'dark:bg-red-900/30 dark:text-red-400'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards.map((stat, index) => (
        <StatCard
          key={index}
          title={stat.title}
          value={stat.value}
          icon={stat.icon}
          color={stat.color}
          darkColor={stat.darkColor}
        />
      ))}
    </div>
  );
};